import { Group, Image, Layer, Rect, Stage, Text } from 'react-konva';
import React, { useEffect, useRef, useState } from 'react';
import {
  addNewArr,
  fcConfirmX,
  fcConfirmY,
  fcNumberKey,
  isCancel,
  tenantAttributeInfos,
} from '../../pages/Attribute/AttributeSlice';
import { useDispatch, useSelector } from 'react-redux';

import ContextMenu from './ContextMenu';
import DeleteDiagram from './ElementDiagram/DeleteDiagram';
import EditDiagram from './ElementDiagram/EditDiagram';
import ModalConfiguration from '../Modal/ModalConfiguration';
import ModalDiagram from '../Modal/ModalDiagram';
import ModalNotifyOffline from '../Modal/ModalNotifyOffline';
import Portal from './Portal';
import ResizeRect from './ElementDiagram/ResizeRect';
import TextFrequency from './ElementDiagram/TextFrequency';
import TrafficLight from './ElementDiagram/TrafficLight';
import fan_red from '../../assets/images/fan-blades-red.png';
import icon_auto from '../../assets/images/icons-automatic.png';
import icon_manual from '../../assets/images/icons-manual.png';
import useImage from 'use-image';

// icon diagram

const BackgroundDiagram = ({ width, height, ImageDiagram }) => {
  const [image] = useImage(ImageDiagram);
  return <Image width={width} height={height} image={image} />;
};

const Diagram = ({
  deviceId,
  width,
  height,
  ImageDiagram,
  dataDiagram,
  isDraw,
  isDelete,
  setDelete,
  isEdit,
  setEdit,
  arrMachine,
  setArrMachine,
  pumpState,
  floatState,
  vf,
  togglePumpState,
  diagramFrequency,
  togglePumpMode,
  pumpMode,
  pressure,
  inverter,
  setInverter,
  sendRpc,
  isOperation,
  pressureMax,
  setPressureMax,
  powerState,
  disableTrafficLight
}) => {
  const dispatch = useDispatch();
  const token = localStorage.getItem('token');
  const notify = useSelector((state) => state.attribute.notify);

  //color pressure
  const [color, setColor] = useState('white');
  const [indexAlert, setIndexAlert] = useState([]);

  // image manual & auto
  const [imageManual] = useImage(icon_manual);
  const [imageAuto] = useImage(icon_auto);

  // selected menu
  const [selectedContextMenu, setSelectedContextMenu] = useState();
  const [isShowMenu, setShowMenu] = useState(false);
  const [numberKey, setNumberKey] = useState();
  const [positionKey, setPositionKey] = useState();
  const [modalKey, setModalKey] = useState();
  const [modalLabel, setModalLabel] = useState();
  let cancel = useSelector((state) => state.attribute.cancel);

  const handleContextMenu = (e, position, type) => {
    e.evt.preventDefault(true); // NB!!!! Remember the ***TRUE***
    if (type !== 'light')
      if (powerState || notify?.unread !== 0) {
        const contextPoint = dataDiagram?.filter(
          (item) => item.topLeftPoint.x === position
        );
        setModalLabel(contextPoint[0].label);
        setModalKey(contextPoint[0].number - 1);
        setPositionKey(position);
        if (type === 'pt' && isOperation) setConfigModal(true);
        else {
          if (!isDraw && !isEdit && isOperation) {
            const mousePosition = e.target.getStage().getPointerPosition();
            setSelectedContextMenu({
              position: mousePosition,
            });
            setShowMenu(true);
          }
        }
      } else {
        setShow(true);
      }
  };

  const closeMenu = (option) => {
    setShowMenu(option);
  };

  // selected drag
  const [show, setShow] = useState(false);
  const [startPoint, setStartPoint] = useState();
  const [endPoint, setEndPoint] = useState();
  const [screenPositionX, setScreenPositionX] = useState();
  const [screenPositionY, setScreenPositionY] = useState();
  const [configModal, setConfigModal] = useState(false);

  const refImage = useRef();
  const layerRef = React.useRef();

  const selectionRectRef = React.useRef();
  const selection = React.useRef({
    visible: false,
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 0,
  });

  //draw box
  const updateSelectionRect = () => {
    const node = selectionRectRef.current;
    node.setAttrs({
      visible: selection.current.visible,
      x: Math.min(selection.current.x1, selection.current.x2),
      y: Math.min(selection.current.y1, selection.current.y2),
      width: Math.abs(selection.current.x1 - selection.current.x2),
      height: Math.abs(selection.current.y1 - selection.current.y2),
      fill: 'rgba(0, 161, 255, 0.3)',
    });
    node.getLayer().batchDraw();
  };

  const onMouseDown = (e) => {
    setShowMenu(false);
    const pos = e.target.getStage().getPointerPosition();
    if (isDraw && !isShowMenu && !isEdit) {
      selection.current.visible = true;
      selection.current.x1 = pos.x;
      selection.current.y1 = pos.y;
      selection.current.x2 = pos.x;
      selection.current.y2 = pos.y;
      updateSelectionRect();

      var PosX = 0;
      var PosY = 0;

      if (!e) var e = window.event;
      if (e.evt.pageX || e.evt.pageY) {
        PosX = e.evt.pageX;
        PosY = e.evt.pageY;

        setStartPoint({ x: PosX, y: PosY });
      } else if (e.evt.clientX || e.evt.clientY) {
        PosX =
          e.evt.clientX +
          document.body.scrollLeft +
          document.documentElement.scrollLeft;
        PosY =
          e.evt.clientY +
          document.body.scrollTop +
          document.documentElement.scrollTop;

        setStartPoint({ x: PosX, y: PosY });
      }
    }
  };

  const onMouseMove = (e) => {
    if (!isShowMenu && isDraw && !isEdit) {
      if (!selection.current.visible) {
        return;
      }
      const pos = e.target.getStage().getPointerPosition();
      selection.current.x2 = pos.x;
      selection.current.y2 = pos.y;
      updateSelectionRect();
    }
  };

  const onMouseUp = (e) => {
    if (isDraw && !isShowMenu && !isEdit) {
      if (!selection.current.visible) {
        return;
      }
      var PosX = 0;
      var PosY = 0;

      if (e.evt.pageX || e.evt.pageY) {
        PosX = e.evt.pageX;
        PosY = e.evt.pageY;

        setEndPoint({ x: PosX, y: PosY });
      } else if (e.evt.clientX || e.evt.clientY) {
        PosX =
          e.evt.clientX +
          document.body.scrollLeft +
          document.documentElement.scrollLeft;
        PosY =
          e.evt.clientY +
          document.body.scrollTop +
          document.documentElement.scrollTop;

        setEndPoint({ x: PosX, y: PosY });
      }
      selection.current.visible = false;
      updateSelectionRect();
      if (!(PosX === startPoint.x && PosY === startPoint.y)) setShow(true);
    }
  };

  const [confirmX, setConfirmX] = useState();
  const [confirmY, setConfirmY] = useState();

  const handleDragStart = (id) => {
    setNumberKey(id);
  };

  const handleDragEnd = (e) => {
    let confirmX = e.target._lastPos.x;
    let confirmY = e.target._lastPos.y;
    if (confirmX <= 0) {
      confirmX = 0;
    }
    if (confirmY <= 0) {
      confirmY = 0;
    }
    if (confirmX >= width) {
      confirmX = width - 5;
    }
    if (confirmY >= height) {
      confirmY = height - 40;
    }
    setConfirmX(confirmX);
    setConfirmY(confirmY);
  };

  // status machine
  let arrIndexPump = [],
    arrIndexFloat = [],
    arrIndexVf = [];

  if (pumpState?.length > 0) {
    pumpState.forEach((elm, index) => {
      elm &&
        arrIndexPump.push(...arrIndexPump, [
          {
            index: index + 1,
            type: 'pump',
          },
        ]);
    });
  }

  if (floatState?.length > 0) {
    floatState.forEach((elm, index) => {
      elm &&
        arrIndexFloat.push(...arrIndexFloat, [
          {
            index: index + 1,
            type: 'float',
          },
        ]);
    });
  }
  if (vf?.length > 0) {
    vf.forEach((elm, index) => {
      elm &&
        arrIndexVf.push(...arrIndexVf, [
          {
            index: index + 1,
            type: 'vf',
          },
        ]);
    });
  }

  const handleSaveFrequency = (number, value) => {
    sendRpc(`inverter${number}`, value);
  };

  useEffect(() => {
    if (dataDiagram.length > 0 && arrMachine?.length <= dataDiagram.length) {
      setArrMachine(dataDiagram);
      dispatch(isCancel(false));
    }
  }, [isDraw, show, dataDiagram]);

  const [imageRed] = useImage(fan_red);

  //limit dragging
  const stageRef = useRef();
  const ref = useRef([]);
  ref?.current.map((r) => {
    r?.on('dragmove', () => {
      r?.y(Math.max(r?.y(), 0));
      r?.y(
        Math.min(
          r?.y(),
          stageRef?.current.attrs.height - r?.children[0].attrs.height - 1
        )
      );
      r?.x(Math.max(r?.x(), 0));
      r?.x(
        Math.min(
          r?.x(),
          stageRef?.current.attrs.width - r?.children[0].attrs.width - 1
        )
      );
    });
  });

  // resize float -------------------------------------
  const [rectangles, setRectangles] = React.useState();
  const [selectedId, selectShape] = React.useState(null);

  useEffect(() => {
    let dataFloat = (isDraw || isEdit ? arrMachine : dataDiagram)?.filter(
      (item) => item.type === 'float'
    );
    if (width !== 0) {
      let initialRectangles = dataFloat.map((item) => ({
        x: item.topRightPoint.x * width - item.widthScreenshot * width,
        y: item.topRightPoint.y * height,
        width: item.widthScreenshot * width,
        height: item.heightScreenshot * height,
        topLeftPoint: item.topLeftPoint,
        fill: 'red',
        id: item.number,
        label: item.label.toUpperCase(),
        screenPosition: item.screenPosition,
      }));
      setRectangles(initialRectangles);
    }
  }, [
    width,
    height,
    cancel,
    arrMachine?.length,
    dataDiagram?.length,
    arrMachine,
  ]);

  useEffect(() => {
    if (!isEdit) {
      selectShape(null);
      dispatch(isCancel(false));
    }
    dispatch(addNewArr(rectangles));
  }, [isEdit, rectangles, dataDiagram]);

  useEffect(() => {
    if (!show) setEndPoint({});
    dispatch(tenantAttributeInfos({ token }));
  }, [show]);

  useEffect(() => {
    dispatch(fcNumberKey(numberKey));
    dispatch(fcConfirmX(confirmX));
    dispatch(fcConfirmY(confirmY));
  }, [numberKey, confirmX, confirmY]);

  function getTextWidth(text, font) {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    context.font = font || getComputedStyle(document.body).font;

    if (text && text?.length > 3) {
      return context.measureText(text).width + 12;
    } else {
      return context.measureText(text).width + 3;
    }
  }

  const calculateX = (item, pressure, inverter, getTextWidth, isEditBtn) => {
    const labelTextWidth = getTextWidth(item.label.toUpperCase());

    if (item.type === 'pt') {
      const vfCondition =
        item.type === 'vf'
          ? inverter[item.number - 1] + ' Hz'
          : item.unit
          ? `${parseFloat(pressure[item.number - 1]).toFixed(2)} ${item.unit}`
          : parseFloat(pressure[item.number - 1]).toFixed(2);

      const condition = labelTextWidth > getTextWidth(vfCondition);
      return condition
        ? labelTextWidth - (isEditBtn ? 30 : 15)
        : getTextWidth(vfCondition) - (isEditBtn ? 25 : 10);
    }

    const labelLength = item.label.length;
    const baseWidth = 10 + labelTextWidth + (isEditBtn ? 0 : 15);

    if (item.type === 'light') {
      return labelLength > 3 ? baseWidth - 20 : baseWidth - 10;
    }

    if (item.type === 'pump' || item.type === 'van') {
      return labelLength > 3 ? baseWidth : baseWidth + 10;
    }

    return labelTextWidth + (isEditBtn ? 15 : 30);
  };

  return (
    <>
      <Stage
        ref={stageRef}
        width={width}
        height={height}
        onMouseDown={onMouseDown}
        onMouseUp={onMouseUp}
        onMouseMove={onMouseMove}
      >
        <Layer ref={layerRef}>
          <BackgroundDiagram
            ImageDiagram={ImageDiagram}
            width={width}
            height={height}
          />
          {rectangles?.map((rect, i) => {
            return (
              <ResizeRect
                key={i}
                isEdit={isEdit}
                shapeProps={rect}
                isSelected={rect.id === selectedId}
                arrIndexFloat={arrIndexFloat}
                setNumberKey={setNumberKey}
                setShow={setShow}
                setEdit={setEdit}
                setDelete={setDelete}
                width={width}
                height={height}
                onSelect={() => {
                  selectShape(rect.id);
                }}
                onChange={(newAttrs) => {
                  const rects = rectangles.slice();
                  rects[i] = newAttrs;
                  setRectangles(rects);
                }}
                handleDragStart={handleDragStart}
              />
            );
          })}
          {cancel &&
            dataDiagram?.map((item, index) => (
              <React.Fragment key={index}>
                <Group
                  ref={(el) => (ref.current[index] = el)}
                  draggable={isEdit}
                  key={item.id}
                  onDragStart={() => handleDragStart(item.topLeftPoint.x)}
                  onDragEnd={(e) => handleDragEnd(e)}
                  id={item.id}
                  x={
                    (item.topRightPoint.x * width + 90 > width
                      ? width - 90
                      : item.topRightPoint.x * width) - 5
                  }
                  y={
                    (item.topRightPoint.y * height < 40
                      ? 40
                      : item.topRightPoint.y * height) - 20
                  }
                >
                  {item.type !== 'float' && width > 0 && (
                    <>
                      <Rect
                        fill={
                          item.type === 'pt' &&
                          indexAlert.includes(item.number - 1)
                            ? color
                            : 'white'
                        }
                        stroke={'black'}
                        strokeWidth={1}
                        onContextMenu={
                          item.type !== 'float' &&
                          ((e) =>
                            handleContextMenu(
                              e,
                              item.topLeftPoint.x,
                              item.type
                            ))
                        }
                        cornerRadius={5}
                        // width={item.type === 'pt' ? 90 : 110}
                        width={
                          item.type === 'pt'
                            ? (getTextWidth(item.label.toUpperCase()) >
                              getTextWidth(
                                item.type === 'vf'
                                  ? inverter[item.number - 1] + ' Hz'
                                  : item.unit
                                  ? `${parseFloat(
                                      pressure[item.number - 1]
                                    ).toFixed(2)} ${item.unit}`
                                  : parseFloat(
                                      pressure[item.number - 1]
                                    ).toFixed(2)
                              )
                                ? getTextWidth(item.label.toUpperCase()) - 5
                                : getTextWidth(
                                    item.type === 'vf'
                                      ? inverter[item.number - 1] + ' Hz'
                                      : item.unit
                                      ? `${parseFloat(
                                          pressure[item.number - 1]
                                        ).toFixed(2)} ${item.unit}`
                                      : parseFloat(
                                          pressure[item.number - 1]
                                        ).toFixed(2)
                                  )) + 10
                            : (item.label.length > 3 ? 25 : 35) +
                              getTextWidth(item.label.toUpperCase()) +
                              (item.type !== 'float' &&
                              item.type !== 'pt' &&
                              item.type !== 'light'
                                ? 18
                                : 0)
                        }
                        height={
                          item.type === 'vf' || item.type === 'pt' ? 36 : 26
                        }
                        shadowColor="black"
                        shadowBlur={10}
                        shadowOpacity={0.5}
                      />
                      {/* label */}
                      <Text
                        text={item.label.toUpperCase()}
                        onContextMenu={
                          item.type !== 'float' &&
                          ((e) =>
                            handleContextMenu(
                              e,
                              item.topLeftPoint.x,
                              item.type
                            ))
                        }
                        x={item.type === 'pt' ? 11 : 30}
                        y={8}
                        fontSize={10}
                        fill={'black'}
                      />
                    </>
                  )}
                  {item.type !== 'float' &&
                    item.type !== 'pump' &&
                    item.type !== 'van' &&
                    item.type !== 'light' && (
                      <TextFrequency
                        indexAlert={indexAlert}
                        setIndexAlert={setIndexAlert}
                        item={item}
                        width={width}
                        height={height}
                        diagramFrequency={diagramFrequency}
                        pressure={pressure}
                        inverter={inverter}
                        color={color}
                        setColor={setColor}
                        pressureMax={pressureMax}
                      />
                    )}
                  {/*  manual && auto */}
                  {item.type !== 'float' &&
                    item.type !== 'pt' &&
                    item.type !== 'light' && (
                      <Image
                        width={18}
                        height={16}
                        x={
                          (item.label.length > 3 ? 20 : 30) +
                          getTextWidth(item.label.toUpperCase())
                        }
                        y={5}
                        image={
                          pumpMode[item.number - 1] ? imageAuto : imageManual
                        }
                        onContextMenu={(e) =>
                          handleContextMenu(e, item.topLeftPoint.x, item.type)
                        }
                      />
                    )}
                  {((item.type === 'pump' &&
                    !arrIndexPump.find(
                      (elm) => elm[0].index === item.number
                    )) ||
                    (item.type === 'vf' &&
                      !arrIndexPump.find(
                        (elm) => elm[0].index === item.number
                      ))) && (
                    <Image
                      offsetX={10}
                      offsetY={10}
                      x={14}
                      y={item.type === 'pump' ? 13 : 16}
                      image={imageRed}
                      width={20}
                      height={20}
                      onContextMenu={(e) =>
                        handleContextMenu(e, item.topLeftPoint.x, item.type)
                      }
                    />
                  )}
                  <TrafficLight
                  disableTrafficLight={disableTrafficLight}
                    item={item}
                    arrIndexPump={arrIndexPump}
                    arrIndexFloat={arrIndexFloat}
                    handleContextMenu={handleContextMenu}
                  />
                  {isEdit && item.type !== 'float' && (
                    <>
                      <EditDiagram
                        numberKey={item.topLeftPoint.x}
                        setNumberKey={setNumberKey}
                        x={calculateX(
                          item,
                          pressure,
                          inverter,
                          getTextWidth,
                          true
                        )}
                        y={item.type === 'float' ? 0 : -20}
                        setShow={setShow}
                        setEdit={setEdit}
                      />
                      <DeleteDiagram
                        numberKey={item.topLeftPoint.x}
                        setNumberKey={setNumberKey}
                        setShow={setShow}
                        setDelete={setDelete}
                        x={calculateX(
                          item,
                          pressure,
                          inverter,
                          getTextWidth,
                          false
                        )}
                        y={item.type === 'float' ? 0 : -20}
                      />
                    </>
                  )}
                  {selectedContextMenu && (
                    <Portal>
                      {isShowMenu && (
                        <ContextMenu
                          {...selectedContextMenu}
                          closeMenu={closeMenu}
                          positionKey={positionKey}
                          dataDiagram={dataDiagram}
                          togglePumpState={togglePumpState}
                          togglePumpMode={togglePumpMode}
                          pumpMode={pumpMode}
                          arrIndexPump={arrIndexPump}
                          arrIndexVf={arrIndexVf}
                          handleSaveFrequency={handleSaveFrequency}
                          inverter={inverter}
                          setInverter={setInverter}
                          pressureMax={pressureMax}
                          setPressureMax={setPressureMax}
                        />
                      )}
                    </Portal>
                  )}
                </Group>
              </React.Fragment>
            ))}
          {(!cancel || isDraw) &&
            arrMachine?.map((item, index) => (
              <React.Fragment key={index}>
                <Group
                  ref={(el) => (ref.current[index] = el)}
                  draggable={isEdit}
                  key={item.id}
                  onDragStart={() => handleDragStart(item.topLeftPoint.x)}
                  onDragEnd={(e) => handleDragEnd(e)}
                  id={item.id}
                  x={
                    (item.topRightPoint.x * width + 90 > width
                      ? width - 90
                      : item.topRightPoint.x * width) - 5
                  }
                  y={
                    (item.topRightPoint.y * height < 40
                      ? 40
                      : item.topRightPoint.y * height) - 20
                  }
                >
                  {item.type !== 'float' && width > 0 && (
                    <>
                      <Rect
                        fill={
                          item.type === 'pt' &&
                          indexAlert.includes(item.number - 1)
                            ? color
                            : 'white'
                        }
                        stroke={'black'}
                        strokeWidth={1}
                        onContextMenu={
                          item.type !== 'float' &&
                          ((e) =>
                            handleContextMenu(
                              e,
                              item.topLeftPoint.x,
                              item.type
                            ))
                        }
                        cornerRadius={5}
                        // width={item.type === 'pt' ? 90 : 110}
                        width={
                          item.type === 'pt'
                            ? (getTextWidth(item.label.toUpperCase()) >
                              getTextWidth(
                                item.type === 'vf'
                                  ? inverter[item.number - 1] + ' Hz'
                                  : item.unit
                                  ? `${parseFloat(
                                      pressure[item.number - 1]
                                    ).toFixed(2)} ${item.unit}`
                                  : parseFloat(
                                      pressure[item.number - 1]
                                    ).toFixed(2)
                              )
                                ? getTextWidth(item.label.toUpperCase()) - 5
                                : getTextWidth(
                                    item.type === 'vf'
                                      ? inverter[item.number - 1] + ' Hz'
                                      : item.unit
                                      ? `${parseFloat(
                                          pressure[item.number - 1]
                                        ).toFixed(2)} ${item.unit}`
                                      : parseFloat(
                                          pressure[item.number - 1]
                                        ).toFixed(2)
                                  )) + 10
                            : (item.label.length > 3 ? 25 : 35) +
                              getTextWidth(item.label.toUpperCase()) +
                              (item.type !== 'float' &&
                              item.type !== 'pt' &&
                              item.type !== 'light'
                                ? 18
                                : 0)
                        }
                        height={
                          item.type === 'vf' || item.type === 'pt' ? 36 : 26
                        }
                        shadowColor="black"
                        shadowBlur={10}
                        shadowOpacity={0.5}
                      />
                      {/* label */}
                      <Text
                        text={item.label.toUpperCase()}
                        onContextMenu={
                          item.type !== 'float' &&
                          ((e) =>
                            handleContextMenu(
                              e,
                              item.topLeftPoint.x,
                              item.type
                            ))
                        }
                        x={item.type === 'pt' ? 11 : 30}
                        y={8}
                        fontSize={10}
                        fill={'black'}
                      />
                    </>
                  )}
                  {item.type !== 'float' &&
                    item.type !== 'pump' &&
                    item.type !== 'van' &&
                    item.type !== 'light' && (
                      <TextFrequency
                        indexAlert={indexAlert}
                        setIndexAlert={setIndexAlert}
                        item={item}
                        width={width}
                        height={height}
                        diagramFrequency={diagramFrequency}
                        pressure={pressure}
                        inverter={inverter}
                        color={color}
                        setColor={setColor}
                        pressureMax={pressureMax}
                      />
                    )}
                  {/*  manual && auto */}
                  {item.type !== 'float' &&
                    item.type !== 'pt' &&
                    item.type !== 'light' && (
                      <Image
                        width={18}
                        height={16}
                        x={
                          (item.label.length > 3 ? 20 : 30) +
                          getTextWidth(item.label.toUpperCase())
                        }
                        y={5}
                        image={
                          pumpMode[item.number - 1] ? imageAuto : imageManual
                        }
                        onContextMenu={(e) =>
                          handleContextMenu(e, item.topLeftPoint.x, item.type)
                        }
                      />
                    )}
                  {((item.type === 'pump' &&
                    !arrIndexPump.find(
                      (elm) => elm[0].index === item.number
                    )) ||
                    (item.type === 'vf' &&
                      !arrIndexPump.find(
                        (elm) => elm[0].index === item.number
                      ))) && (
                    <Image
                      offsetX={10}
                      offsetY={10}
                      x={14}
                      y={item.type === 'pump' ? 13 : 16}
                      image={imageRed}
                      width={20}
                      height={20}
                      onContextMenu={(e) =>
                        handleContextMenu(e, item.topLeftPoint.x, item.type)
                      }
                    />
                  )}
                  <TrafficLight
                    item={item}
                    arrIndexPump={arrIndexPump}
                    arrIndexFloat={arrIndexFloat}
                    handleContextMenu={handleContextMenu}
                  />
                  {isEdit && item.type !== 'float' && (
                    <>
                      <EditDiagram
                        numberKey={item.topLeftPoint.x}
                        setNumberKey={setNumberKey}
                        x={calculateX(
                          item,
                          pressure,
                          inverter,
                          getTextWidth,
                          true
                        )}
                        y={item.type === 'float' ? 0 : -20}
                        setShow={setShow}
                        setEdit={setEdit}
                      />
                      <DeleteDiagram
                        numberKey={item.topLeftPoint.x}
                        setNumberKey={setNumberKey}
                        setShow={setShow}
                        setDelete={setDelete}
                        x={calculateX(
                          item,
                          pressure,
                          inverter,
                          getTextWidth,
                          false
                        )}
                        y={item.type === 'float' ? 0 : -20}
                      />
                    </>
                  )}
                  {selectedContextMenu && (
                    <Portal>
                      {isShowMenu && (
                        <ContextMenu
                          {...selectedContextMenu}
                          closeMenu={closeMenu}
                          positionKey={positionKey}
                          dataDiagram={dataDiagram}
                          togglePumpState={togglePumpState}
                          togglePumpMode={togglePumpMode}
                          pumpMode={pumpMode}
                          arrIndexPump={arrIndexPump}
                          arrIndexVf={arrIndexVf}
                          handleSaveFrequency={handleSaveFrequency}
                          inverter={inverter}
                          setInverter={setInverter}
                          pressureMax={pressureMax}
                          setPressureMax={setPressureMax}
                        />
                      )}
                    </Portal>
                  )}
                </Group>
              </React.Fragment>
            ))}
          <Rect fill="rgba(0,0,255,0.5)" ref={selectionRectRef} />
        </Layer>
      </Stage>
      <ModalConfiguration
        show={configModal}
        setShow={setConfigModal}
        pressureMax={pressureMax}
        index={modalKey}
        label={modalLabel}
        sendRpc={sendRpc}
        setPressureMax={setPressureMax}
      />
      {show && !isShowMenu && powerState && (
        <ModalDiagram
          deviceId={deviceId}
          numberKey={numberKey}
          isEdit={isEdit}
          isDraw={isDraw}
          isDelete={isDelete}
          setEdit={setEdit}
          setDelete={setDelete}
          refImage={refImage}
          width={width}
          height={height}
          show={show}
          setShow={setShow}
          startPoint={startPoint}
          endPoint={endPoint}
          dataDiagram={dataDiagram}
          arrMachine={arrMachine}
          setArrMachine={setArrMachine}
          handleSaveFrequency={handleSaveFrequency}
          inverter={inverter}
          setInverter={setInverter}
          screenPositionX={screenPositionX}
          setScreenPositionX={setScreenPositionX}
          screenPositionY={screenPositionY}
          setScreenPositionY={setScreenPositionY}
        />
      )}
      {show && !powerState && (
        <ModalNotifyOffline
          show={show}
          setShow={setShow}
          notify={notify?.unread}
        />
      )}
      <img
        className="img-vitural"
        ref={refImage}
        width={width}
        height={height}
        src={ImageDiagram}
        alt="diagram-virtual"
      />
    </>
  );
};

export default Diagram;
